import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GA_MEASUREMENT_ID } from "../../config";


export function GoogleAnalytics() {
    const { pathname } = useLocation();

    useEffect(() => {
        gtag("config", GA_MEASUREMENT_ID, {
            "page_path": pathname,
        });
    }, [pathname]);

    return null;
}
